import React from "react";
import LegalLayout from "./LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout
      title="TERMOS E CONDIÇÕES DE USO"
      subtitle="Leia com atenção antes de adquirir o curso. A aquisição implica aceitação integral destes termos."
      lastUpdated="30 de dezembro de 2025"
    >
      {/* Legal notice */}
      <div className="border border-yellow-400/30 bg-yellow-400/5 p-5 text-sm text-zinc-200">
        <strong className="text-yellow-400">Aviso importante:</strong> O presente documento constitui
        o contrato entre o utilizador (Aluno) e Kawan Oliveira (Formador/Prestador). Ao realizar a
        compra através da plataforma Hotmart, o Aluno declara ter lido, compreendido e aceite
        integralmente estes Termos e a Política de Privacidade.
      </div>

      <h2><span className="num">1.</span> Identificação das Partes</h2>
      <p>
        <strong>Produtor e Formador:</strong>
        <br />
        Nome comercial: Kawan Gruista — Escola do Manobrador
        <br />
        Titular: Kawan Oliveira
        <br />
        Telefone / WhatsApp:{" "}
        <a href="https://wa.me/351963448484" target="_blank" rel="noopener noreferrer">
          +351 963 448 484
        </a>
        <br />
        Email:{" "}
        <a href="mailto:info@manobradordegruakawan.com">info@manobradordegruakawan.com</a>
      </p>
      <p>
        <strong>Plataforma de Venda, Pagamento e Alojamento (Hotmart):</strong>
        <br />
        <strong>Hotmart BV</strong> — sociedade responsável pela comercialização, cobrança,
        emissão de fatura/recibo, disponibilização da área de membros e processamento de
        reembolsos. Sede: WTC Schiphol Airport, Schiphol Boulevard 395, 1118 BJ Schiphol, Países
        Baixos.
        <br />
        Termos e Política de Privacidade da Hotmart:{" "}
        <a href="https://www.hotmart.com/pt-br/legal" target="_blank" rel="noopener noreferrer">
          hotmart.com/pt-br/legal
        </a>
        .
      </p>
      <p>
        <strong>Livro de Reclamações Eletrónico:</strong> disponibilizado em{" "}
        <a href="https://www.livroreclamacoes.pt/" target="_blank" rel="noopener noreferrer">
          livroreclamacoes.pt
        </a>
        .
      </p>

      <h2><span className="num">2.</span> Natureza da Relação Contratual</h2>
      <p>
        A compra do curso é celebrada <strong>entre o Aluno (Consumidor) e a Hotmart BV
        (Vendedora)</strong>. A Hotmart é a contraparte comercial do Aluno para efeitos de
        pagamento, emissão de fatura/recibo, entrega do acesso digital e processamento de
        reembolsos, aplicando-se adicionalmente os{" "}
        <a href="https://www.hotmart.com/pt-br/legal" target="_blank" rel="noopener noreferrer">
          Termos de Uso e Política de Privacidade da Hotmart
        </a>
        , que o Aluno aceita no momento da compra.
      </p>
      <p>
        Kawan Oliveira atua como <strong>produtor e formador do conteúdo</strong>, sendo o autor
        das aulas, materiais e metodologia, e colaborando com a entidade certificadora para a
        emissão do cartão de Manobrador (Pacote Completo). As obrigações de pós-venda (acesso,
        reembolso, fatura) são executadas através da Hotmart.
      </p>

      <h2><span className="num">3.</span> Objeto do Contrato</h2>
      <p>
        Os presentes Termos regulam a aquisição e utilização do curso online{" "}
        <strong>"Manobrador de Grua Torre"</strong>, produto digital composto por aulas gravadas em
        vídeo, materiais de apoio e, consoante o pacote adquirido, avaliação teórica online e
        certificação.
      </p>
      <p>
        <strong>Dois pacotes disponíveis:</strong>
      </p>
      <ul>
        <li>
          <strong>Pacote Essencial (€37 + IVA):</strong> acesso às aulas gravadas, materiais de apoio
          e orientação profissional. <strong>Não inclui</strong> avaliação teórica nem certificação
          SIGO / Passaporte Qualifica.
        </li>
        <li>
          <strong>Pacote Completo (€147):</strong> tudo o que está incluído no Pacote Essencial,
          acrescido de avaliação teórica online e <strong>certificação de 15h via SIGO /
          Passaporte Qualifica (CFOMP)</strong>, com emissão do cartão de Manobrador.
        </li>
      </ul>

      <h2><span className="num">4.</span> Natureza do Serviço · Certificação</h2>
      <p>
        O curso consiste em <strong>formação teórica online</strong>. A certificação no Pacote
        Completo é emitida por entidade formadora certificada{" "}
        <strong>CFOMP International / Escola do Manobrador</strong>, devidamente reconhecida pelo
        Sistema de Informação e Gestão da Oferta Educativa e Formativa (SIGO) e registada no
        Passaporte Qualifica.
      </p>
      <p>
        O Aluno reconhece que: (i) a certificação depende da conclusão integral dos módulos e da
        aprovação na avaliação teórica; (ii) o curso constitui formação <strong>teórica</strong>,
        podendo a legislação aplicável em cada obra ou empregador exigir componente prática
        complementar, a qual <strong>não está incluída</strong> no preço do curso; (iii) o emprego
        subsequente depende de múltiplos fatores externos, não sendo garantido pelo Prestador.
      </p>

      <h2><span className="num">4.</span> Aula Prática Presencial (Serviço Opcional)</h2>
      <p>
        A aula prática presencial com Kawan Oliveira em grua de comando real é um{" "}
        <strong>serviço autónomo, opcional e pago à parte</strong>, não incluído em qualquer um dos
        pacotes do curso online. Alunos do curso online beneficiam de desconto exclusivo sobre o
        valor público, mediante disponibilidade de agenda e vagas. Os termos específicos desta aula
        serão comunicados individualmente a cada aluno interessado.
      </p>

      <h2><span className="num">6.</span> Preço, Pagamento, Fatura e IVA</h2>
      <p>
        Os preços apresentados na página de vendas são válidos à data da compra. O pagamento é
        único, realizado integralmente através da <strong>Hotmart</strong>, com acesso imediato
        após confirmação.
      </p>
      <p>
        A <strong>fatura/recibo eletrónico</strong> é emitida pela Hotmart BV (ou entidade do
        grupo Hotmart competente em cada jurisdição), que atua como vendedora de registo e é
        responsável pelas obrigações fiscais, incluindo o IVA aplicável (por exemplo, o IVA
        intracomunitário de bens e serviços digitais — OSS/MOSS). O Aluno receberá a fatura no
        email indicado na compra.
      </p>
      <p>
        O Prestador <strong>não armazena dados de cartão</strong>; toda a informação de pagamento
        é processada pela Hotmart em conformidade com os padrões PCI-DSS.
      </p>

      <h2><span className="num">7.</span> Acesso e Prazo de Validade</h2>
      <p>
        Após a confirmação do pagamento, o Aluno recebe por email o acesso à área de membros Hotmart
        (login e password), válido por <strong>12 (doze) meses</strong> a contar da data da compra.
        Durante este período, o Aluno pode aceder às aulas, materiais e eventuais atualizações
        disponibilizadas.
      </p>
      <p>
        O acesso é <strong>pessoal e intransmissível</strong>. A partilha de credenciais, cópia,
        redistribuição, upload, exibição pública ou qualquer outra utilização não autorizada
        constituem violação dos presentes Termos e podem resultar no bloqueio imediato do acesso,
        sem direito a reembolso, sem prejuízo de responsabilização civil e criminal nos termos da
        lei.
      </p>

      <h2><span className="num">7.</span> Direito de Livre Resolução · Garantia de 14 Dias</h2>
      <p>
        Nos termos do <strong>Decreto-Lei n.º 24/2014, de 14 de fevereiro</strong> (Contratos
        Celebrados à Distância), o consumidor tem, em regra, direito a resolver o contrato no prazo
        de 14 dias, sem necessidade de indicar motivo.
      </p>
      <p>
        <strong>Garantia comercial voluntária:</strong> independentemente das exceções legais
        aplicáveis a conteúdos digitais (nomeadamente o artigo 17.º, n.º 1, alínea m) do referido
        diploma), o Produtor oferece, em conjunto com a Hotmart,{" "}
        <strong>garantia incondicional de reembolso integral no prazo de 14 dias corridos</strong>,
        a contar da data da compra, mediante simples pedido enviado
        para <a href="mailto:info@manobradordegruakawan.com">info@manobradordegruakawan.com</a>
        {" "}ou diretamente na área "A Minha Conta" da Hotmart.
      </p>
      <p>
        Após o prazo de 14 dias, não haverá lugar a reembolso, sem prejuízo dos direitos
        imperativos de conformidade do produto digital previstos no{" "}
        <strong>Decreto-Lei n.º 84/2021</strong> (conteúdos e serviços digitais). O pedido de
        reembolso é processado pela plataforma Hotmart, podendo demorar até 30 dias para
        restituição integral do valor no método de pagamento original.
      </p>

      <h2><span className="num">9.</span> Propriedade Intelectual</h2>
      <p>
        Todos os conteúdos do curso (vídeos, textos, apresentações, áudios, marcas, logótipos,
        metodologia, estrutura curricular) são propriedade intelectual exclusiva de Kawan Oliveira
        e/ou dos respetivos licenciantes, protegidos pelo{" "}
        <strong>Código do Direito de Autor e dos Direitos Conexos</strong> (Decreto-Lei n.º
        63/85) e pela legislação da União Europeia aplicável.
      </p>
      <p>
        É <strong>expressamente proibido</strong>: (i) copiar, reproduzir, modificar, traduzir,
        descompilar, distribuir ou comunicar ao público qualquer parte do conteúdo; (ii) gravar,
        transmitir ou armazenar as aulas em qualquer suporte; (iii) utilizar o conteúdo para fins
        comerciais, formativos próprios ou qualquer outra finalidade não expressamente autorizada
        por escrito pelo Prestador.
      </p>

      <h2><span className="num">10.</span> Deveres do Aluno</h2>
      <ul>
        <li>Fornecer dados verdadeiros, exatos e atualizados no momento da compra.</li>
        <li>Manter a confidencialidade das credenciais de acesso à plataforma.</li>
        <li>
          Comunicar imediatamente ao Prestador qualquer uso indevido ou não autorizado da sua conta.
        </li>
        <li>
          Respeitar integralmente os direitos de propriedade intelectual referidos na cláusula
          anterior.
        </li>
        <li>
          Abster-se de publicar conteúdos ilícitos, ofensivos, difamatórios ou violadores de
          direitos de terceiros em quaisquer canais oficiais do Prestador.
        </li>
      </ul>

      <h2><span className="num">11.</span> Limitação de Responsabilidade</h2>
      <p>
        O Prestador responde nos exatos termos legais. Sem prejuízo do disposto na lei imperativa
        aplicável a consumidores, o Prestador não será responsável por:
      </p>
      <ul>
        <li>
          Resultados profissionais ou financeiros obtidos pelo Aluno, os quais dependem de fatores
          externos (esforço pessoal, mercado de trabalho, requisitos específicos de empregadores).
        </li>
        <li>
          Interrupções temporárias de acesso à plataforma Hotmart por motivos de manutenção, força
          maior ou causas externas não imputáveis ao Prestador.
        </li>
        <li>
          Decisões de entidades certificadoras terceiras sobre a aceitação do certificado em
          concursos, entrevistas ou atribuições específicas.
        </li>
      </ul>

      <h2><span className="num">12.</span> Alterações aos Termos</h2>
      <p>
        O Prestador reserva-se o direito de alterar os presentes Termos por motivos legais, técnicos
        ou comerciais. As alterações serão comunicadas através do email registado do Aluno com
        antecedência razoável, e produzirão efeitos a partir da data indicada, salvo se o Aluno
        comunicar a sua não aceitação, caso em que poderá resolver o contrato nos termos legais.
      </p>

      <h2><span className="num">13.</span> Resolução de Litígios</h2>
      <p>
        Em matérias diretamente relacionadas com <strong>pagamento, fatura ou acesso à
        plataforma</strong>, o Aluno deve dirigir-se em primeiro lugar ao suporte da Hotmart através
        do centro de ajuda{" "}
        <a href="https://help.hotmart.com" target="_blank" rel="noopener noreferrer">
          help.hotmart.com
        </a>
        .
      </p>
      <p>
        Em matérias relativas ao <strong>conteúdo do curso, certificação ou aulas práticas</strong>,
        o Aluno pode contactar diretamente o Produtor através dos canais indicados na cláusula 1.
      </p>
      <p>
        Em caso de litígio de consumo não resolvido, o Aluno pode recorrer às entidades de
        Resolução Alternativa de Litígios de Consumo (RAL), nomeadamente:
      </p>
      <ul>
        <li>
          <strong>Centro Nacional de Informação e Arbitragem de Conflitos de Consumo (CNIACC):</strong>{" "}
          <a href="https://www.cniacc.pt" target="_blank" rel="noopener noreferrer">
            cniacc.pt
          </a>
        </li>
        <li>
          <strong>Plataforma Europeia de Resolução de Litígios Online (ODR):</strong>{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
          >
            ec.europa.eu/consumers/odr
          </a>
        </li>
        <li>
          Ou, caso prefira, outro centro de arbitragem territorialmente competente, listado em{" "}
          <a href="https://www.consumidor.gov.pt" target="_blank" rel="noopener noreferrer">
            consumidor.gov.pt
          </a>
          .
        </li>
      </ul>
      <p>
        Mais informação sobre a Lei de Defesa do Consumidor (Lei n.º 24/96, de 31 de julho) em{" "}
        <a href="https://www.consumidor.gov.pt" target="_blank" rel="noopener noreferrer">
          consumidor.gov.pt
        </a>
        .
      </p>

      <h2><span className="num">14.</span> Lei Aplicável e Foro</h2>
      <p>
        Os presentes Termos regem-se pela <strong>lei portuguesa</strong>, sem prejuízo das
        disposições imperativas de proteção do consumidor aplicáveis no país de residência
        habitual do Aluno, quando mais favoráveis.
      </p>
      <p>
        Para a resolução de qualquer litígio emergente da interpretação ou execução deste contrato,
        as partes elegem o foro da comarca da sede do Prestador, com expressa renúncia a qualquer
        outro, sem prejuízo do direito do consumidor ao foro do seu domicílio, nos termos legais.
      </p>

      <h2><span className="num">15.</span> Contacto</h2>
      <p>
        <strong>Para conteúdo, certificação, aula prática:</strong>
        <br />
        WhatsApp / Telefone:{" "}
        <a href="https://wa.me/351963448484" target="_blank" rel="noopener noreferrer">
          +351 963 448 484
        </a>
        <br />
        Email:{" "}
        <a href="mailto:info@manobradordegruakawan.com">info@manobradordegruakawan.com</a>
        <br />
        Responsável: Kawan Oliveira
      </p>
      <p>
        <strong>Para pagamento, fatura, reembolso ou acesso à plataforma:</strong>
        <br />
        Suporte Hotmart:{" "}
        <a href="https://help.hotmart.com" target="_blank" rel="noopener noreferrer">
          help.hotmart.com
        </a>
      </p>
    </LegalLayout>
  );
}
